export default __webpack_public_path__ + "static/media/AddONGimg3.41e85da7.png";